import React from "react";
import { useLocation } from "react-router-dom";
import { dateFormat, to12HourFormat } from "../utils/dateFormats";
import "../styles/BookingSuccessPage.scss";

export default function EventBookingSuccessPage() {
  const { state } = useLocation();
  const data = state;
  // Get booking data from localStorage
  // const data = JSON.parse(localStorage.getItem('eventBookingData') || '{}');
  console.log("success data after event booking ===> ",data);

  if (!data) return <div>No event booking data found</div>;

  return (
    <div className="booking-page container py-5 d-flex justify-content-center">
      <div className="booking-card shadow p-4 bg-white">

        {/* HEADER */}
        <div className="row mb-4">
          <div className="col-auto">
            <img
              src={data.event?.thumbnail || require("../assets/images/logo.png")}
              alt="event poster"
              className="poster-img img-fluid rounded shadow-sm"
            />
          </div>

          <div className="col d-flex flex-column justify-content-center">
            <h1 className="h3 fw-bold mb-1">{data?.message || "Booking Successful!"}</h1>

            <p className="text-muted small mb-0">
              <strong>Booking ID:</strong> {data?.booking_id || "N/A"}
            </p>
          </div>
        </div>

        {/* DETAILS */}
        <div className="details-list">
          <Detail label="Event" value={data.event?.heading || data.event?.name} />
          <Detail label="Location" value={data.event?.venue || data.event?.location} />
          <Detail label="Event Date" value={`${dateFormat(data.event?.start_date).split(' ')[0]} - ${dateFormat(data.event?.end_date).split(' ')[0]}`} />
          <Detail label="Event Time" value={to12HourFormat(data.event?.time)} />
          {/* <Detail label="Section" value={data.selectedSection?.title} /> */}
          {/* <Detail label="Quantity" value={data.quantity} /> */}
          <Detail label="Amount" value={`€${(data.amount)}`} />
        </div>

        {/* TICKETS */}
        <h2 className="h4 fw-semibold mt-4">Tickets</h2>

        <div className="table-responsive">
          <table className="table table-bordered table-hover table-sm">
            <thead className="table-light">
              <tr>
                <th>Section</th>
                <th>Quantity</th>
                <th>Price</th>
              </tr>
            </thead>

            <tbody>
              {data.sections && data.sections.map((section, index) => {
                const qty = section.quantity || data.quantity;
                const basePrice = parseFloat(section.price || 0);
                let usedPrice = basePrice;
                if (section.group_prices && Array.isArray(section.group_prices)) {
                  const applicable = section.group_prices
                    .sort((a, b) => a.min_quantity - b.min_quantity)
                    .find(gp => gp.min_quantity === qty);
                  if (applicable) {
                    usedPrice = parseFloat(applicable.group_price);
                  }
                }
                const totalPrice = Math.round(parseFloat(section.group_price).toFixed(2) * qty * 100) / 100;
                return (
                  <tr key={index}>
                    <td>{section.title}</td>
                    <td>{qty}</td>
                    <td>€{parseFloat(section.group_price).toFixed(2)} x {qty} = €{totalPrice.toFixed(2)} + tax</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>

        {/* FOOTER */}
        <p className="text-muted small mt-4">
          Show this confirmation at the event entrance.
        </p>

        <p className="text-center small text-muted">
          If you have questions, contact support.
        </p>

        <p className="text-center small text-secondary">© 2025 Getam</p>

        <div className="text-center mt-4">
          <button className="btn btn-dark px-4" onClick={() => window.print()}>
            Print Ticket
          </button>
        </div>

      </div>
    </div>
  );
}

function Detail({ label, value }) {
  return (
    <div className="detail-row d-flex border-bottom py-2">
      <span className="label fw-medium">{label}</span>
      <span className="value ms-3">{value}</span>
    </div>
  );
}
